<template>
  <div class="ctable">
    <div class="ctable-header" ref="headerContainer">
      <table class="ct-header" :style="{'min-width': minWidth+'px', 'width': '100%'}">
        <thead>
          <tr>
            <th v-for="column in cColumns" :class="column.classes" :style="column.styles" :width="column.width">
              <div v-if="column.name=='checkbox'" class="check">
                <label>
                  <input type="checkbox" v-model="checkAll" />
                  <span><i class="fa-solid fa-check"></i></span>
                </label>
              </div>
              <div v-else-if="column.labelComponent">
                <component :is="column.labelComponent" :column="column" v-bind="column.labelProps || {}" @reload="reload" />
              </div>
              <div v-else>
                {{ column.label }}
              </div>
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="ctable-body" ref="bodyContainer">
      <table class="ct-header" :style="{'min-width': minWidth+'px', 'width': '100%'}">
        <tbody>
          <ScDataTableReportsItem v-for="item in data" :key="'item'+item.uuid" :item="item" :cColumns="cColumns" :checkAll="checkAll" v-model:cRows="cRows" :dataConfig="dataConfig" />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "minWidth", "columns", "checkedRows", "search", "order", "dataConfig"],
  data: ()=>({
    widthMultiplier: 0,
    checkAll: false,
//     cRows: [],
//     shownVariants: {},
  }),
  computed: {
    cRows: {
      get() {
        return this.checkedRows;
      },
      set(value) {
        this.$emit("update:checkedRows", value);
      },
    },
    cColumns() {
      var totalFixedWidth=(this.columns || []).filter(column=>(column.width || "").endsWith("px")).reduce((total,item)=>total+item.width.replace("px", "")*1, 0);
      var totalDynamicWidth=(this.columns || []).filter(column=>(column.width || "").endsWith("%")).reduce((total,item)=>total+item.width.replace("%", "")*1, 0);
      var dynamicWidthMultiplier=(this.minWidth-totalFixedWidth)/totalDynamicWidth;

      var normalizedWidths=(this.columns || []).map(column=>{
        var columnWidth=0;
        if ((column.width || "").endsWith("px")) {
          columnWidth=+(column.width.replace("px", ""));
        } else if ((column.width || "").endsWith("%")) {
          columnWidth=+(column.width.replace("%", ""))*dynamicWidthMultiplier;
        }
        return columnWidth*100/this.minWidth+"%";
      });

      return (this.columns || []).map((column, index)=>{
        var columnLeft=normalizedWidths.reduce((a,v,i)=>a+(i<index?+(v.replace("%", "")):0), 0);
        var columnRight=100-normalizedWidths.reduce((a,v,i)=>a+(i<=index?+(v.replace("%", "")):0), 0);
        var isStart=true;
        var isEnd=true;
        for(var ci in this.columns) {
          if (ci<=index && !this.columns[ci].fixed)
            isStart=false;
          if (ci>=index && !this.columns[ci].fixed)
            isEnd=false;
        }
        return {
          ...column,
          classes: {fixed: this.widthMultiplier && (isStart || isEnd)},
          width: normalizedWidths[index],
          styles: isStart?{
            left: columnLeft/100*this.minWidth*this.widthMultiplier+"px",
          }:(isEnd?{
            right: columnRight/100*this.minWidth*this.widthMultiplier+"px",
          }:{}),
        }
      });
    },
  },
  methods: {
    syncHorizScroll() {
      this.$refs.headerContainer.scrollLeft=this.$refs.bodyContainer.scrollLeft;
    },
    recalcFixed(event) {
      this.widthMultiplier=Math.max(1, event?.[0]?.contentBoxSize?.[0]?.inlineSize/this.minWidth);
    },
    toggleSort(columnName) {
      if (this.order=="+"+columnName) {
        this.$emit("update:order", "-"+columnName);
      } else if (this.order=="-"+columnName) {
        this.$emit("update:order", null);
      } else {
        this.$emit("update:order", "+"+columnName);
      }
    },
    reload() {
      this.$emit("reload");
    },
  },
  mounted() {
    this.syncHorizScroll();
    this.syncHorizScrollBound=this.syncHorizScroll.bind(this);
    this.recalcFixedBound=this.recalcFixed.bind(this);
    this.$refs.bodyContainer.addEventListener("scroll", this.syncHorizScrollBound);
    if (window.ResizeObserver) {
      new ResizeObserver(this.recalcFixedBound).observe(this.$refs.bodyContainer);
    }
  },
  destroyed() {
    this.stores.callbacks.popCallback();
  },
}
</script>
